export const brandCaptionLowerThirdSecondary = {
  type: "string",
  minLength: 1,
  maxLength: 255
};
